<template>
  <div class="course-edit">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <div class="header-left">
          <h2 class="page-title">
            <i class="el-icon-video-camera"></i>
            {{ isEdit ? '编辑课程' : '新增课程' }}
          </h2>
          <p class="page-subtitle">{{ isEdit ? '修改课程信息' : '创建新的课程内容' }}</p>
        </div>
        <div class="header-actions">
          <el-button @click="goBack" icon="el-icon-back">返回</el-button>
          <el-button type="primary" @click="save" :loading="saving" icon="el-icon-check">
            {{ saving ? '保存中...' : '保存' }}
          </el-button>
        </div>
      </div>
    </div>

    <!-- 表单内容 -->
    <div class="form-container">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" class="course-form">

        <!-- 基础信息卡片 -->
        <el-card class="form-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-edit-outline"></i>
            <span>基础信息</span>
          </div>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="课程名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入课程名称，最大30个字符" :maxlength="30" show-word-limit>
                  <i slot="prefix" class="el-icon-edit"></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程分类" prop="typeId">
                <el-select v-model="form.typeId" placeholder="请选择课程分类" style="width: 100%" clearable filterable>
                  <el-option v-for="category in categories" :key="category.id" :label="category.name"
                    :value="String(category.id)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="课程类型" prop="courseType">
                <el-select v-model="form.courseType" placeholder="请选择课程类型" style="width: 100%" clearable>
                  <el-option label="免费" value="1">
                    <span style="color: #67C23A;">
                      <i class="el-icon-check"></i> 免费
                    </span>
                  </el-option>
                  <el-option label="VIP" value="2">
                    <span style="color: #E6A23C;">
                      <i class="el-icon-star-on"></i> VIP
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运动时长（秒）" prop="exerciseDurationSec">
                <el-input-number v-model="form.exerciseDurationSec" :min="0" :max="86400" placeholder="请输入运动时长（秒）" style="width: 100%">
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="适合人群" prop="targetPeople">
                <el-select v-model="form.targetPeople" placeholder="请选择适合人群" style="width: 100%" clearable>
                  <el-option label="零基础" value="1">
                    <span style="color: #909399;">
                      <i class="el-icon-user"></i> 零基础
                    </span>
                  </el-option>
                  <el-option label="运动小白" value="2">
                    <span style="color: #67C23A;">
                      <i class="el-icon-user-solid"></i> 运动小白
                    </span>
                  </el-option>
                  <el-option label="初级运动者" value="3">
                    <span style="color: #409EFF;">
                      <i class="el-icon-star-off"></i> 初级运动者
                    </span>
                  </el-option>
                  <el-option label="中级运动者" value="4">
                    <span style="color: #E6A23C;">
                      <i class="el-icon-star-on"></i> 中级运动者
                    </span>
                  </el-option>
                  <el-option label="高级运动者" value="5">
                    <span style="color: #F56C6C;">
                      <i class="el-icon-trophy"></i> 高级运动者
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动部位" prop="targetBodyParts">
                <el-input v-model="form.targetBodyParts" placeholder="请输入活动部位，如：手臂、腿部、腹部" :maxlength="50" show-word-limit>
                  <i slot="prefix" class="el-icon-location-outline"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="是否推荐">
                <el-switch v-model="form.recommend" :active-value="1" :inactive-value="0" active-text="推荐"
                  inactive-text="不推荐" active-color="#13ce66">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否上架">
                <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="上架"
                  inactive-text="下架" active-color="#409EFF">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 媒体资源卡片 -->
        <el-card class="form-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-picture-outline"></i>
            <span>媒体资源</span>
          </div>

          <el-row :gutter="24">

            <el-col :span="12">
              <el-form-item label="课程图片">
                <div class="media-upload-container">
                  <el-upload class="image-uploader" action="#" :auto-upload="false" :show-file-list="false"
                    :on-change="handleImageChange" :before-upload="beforeImageUpload" accept="image/jpeg,image/png">

                    <!-- 上传成功后显示图片 -->
                    <div v-if="(form.pictureUrl || previewImageUrl) && !imageUploading" class="uploaded-content">
                      <img :src="form.pictureUrl || previewImageUrl" class="uploaded-image">
                      <div class="upload-overlay" @click.stop>
                        <div class="upload-actions">
                          <el-button type="text" icon="el-icon-view" @click.stop="previewImage">预览</el-button>
                          <el-button type="text" icon="el-icon-delete" @click.stop="removeImage">删除</el-button>
                        </div>
                      </div>
                    </div>

                    <!-- 上传中显示进度 -->
                    <div v-else-if="imageUploading" class="upload-progress-container">
                      <div class="progress-content">
                        <i class="el-icon-loading upload-loading"></i>
                        <div class="progress-text">上传中...</div>
                        <el-progress :percentage="imageUploadProgress" :show-text="false" :stroke-width="4"
                          color="#409eff">
                        </el-progress>
                        <div class="progress-percentage">{{ imageUploadProgress }}%</div>
                      </div>
                    </div>

                    <!-- 默认上传区域 -->
                    <div v-else class="upload-placeholder">
                      <div class="upload-icon-container">
                        <i class="el-icon-plus upload-icon"></i>
                      </div>
                      <div class="upload-text">点击上传图片</div>
                      <div class="upload-tips">支持 JPG、PNG 格式，大小不超过 2MB</div>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程视频">
                <div class="media-upload-container">
                  <el-upload class="video-uploader" action="#" :auto-upload="false" :show-file-list="false"
                    :on-change="handleVideoChange" :before-upload="beforeVideoUpload"
                    accept="video/mp4,video/avi,video/mov">

                    <!-- 上传成功后显示视频 -->
                    <div v-if="(form.videoUrl || previewVideoUrl) && !videoUploading" class="uploaded-content">
                      <div class="video-preview">
                        <video :src="form.videoUrl || previewVideoUrl" controls class="preview-video"></video>
                        <div class="video-name">{{ videoFileName }}</div>
                      </div>
                      <div class="upload-overlay" @click.stop>
                        <div class="upload-actions">
                          <el-button type="text" icon="el-icon-view" @click.stop="previewVideo">预览</el-button>
                          <el-button type="text" icon="el-icon-delete" @click.stop="removeVideo">删除</el-button>
                        </div>
                      </div>
                    </div>

                    <!-- 上传中显示进度 -->
                    <div v-else-if="videoUploading" class="upload-progress-container">
                      <div class="progress-content">
                        <i class="el-icon-loading upload-loading"></i>
                        <div class="progress-text">上传中...</div>
                        <el-progress :percentage="videoUploadProgress" :show-text="false" :stroke-width="4"
                          color="#409eff">
                        </el-progress>
                        <div class="progress-percentage">{{ videoUploadProgress }}%</div>
                      </div>
                    </div>

                    <!-- 默认上传区域 -->
                    <div v-else class="upload-placeholder">
                      <div class="upload-icon-container">
                        <i class="el-icon-video-camera upload-icon"></i>
                      </div>
                      <div class="upload-text">点击上传视频</div>
                      <div class="upload-tips">支持 MP4 格式，大小不超过 100MB</div>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程封面">
                <div class="media-upload-container">
                  <el-upload class="image-uploader" action="#" :auto-upload="false" :show-file-list="false"
                    :on-change="handleCoverChange" :before-upload="beforeImageUpload" accept="image/jpeg,image/png">

                    <!-- 上传成功后显示图片 -->
                    <div v-if="(form.coverUrl || previewCoverUrl) && !coverUploading" class="uploaded-content">
                      <img :src="form.coverUrl || previewCoverUrl" class="uploaded-image">
                      <div class="upload-overlay" @click.stop>
                        <div class="upload-actions">
                          <el-button type="text" icon="el-icon-view" @click.stop="previewCover">预览</el-button>
                          <el-button type="text" icon="el-icon-delete" @click.stop="removeCover">删除</el-button>
                        </div>
                      </div>
                    </div>

                    <!-- 上传中显示进度 -->
                    <div v-else-if="coverUploading" class="upload-progress-container">
                      <div class="progress-content">
                        <i class="el-icon-loading upload-loading"></i>
                        <div class="progress-text">上传中...</div>
                        <el-progress :percentage="coverUploadProgress" :show-text="false" :stroke-width="4"
                          color="#409eff">
                        </el-progress>
                        <div class="progress-percentage">{{ coverUploadProgress }}%</div>
                      </div>
                    </div>

                    <!-- 默认上传区域 -->
                    <div v-else class="upload-placeholder">
                      <div class="upload-icon-container">
                        <i class="el-icon-plus upload-icon"></i>
                      </div>
                      <div class="upload-text">点击上传封面</div>
                      <div class="upload-tips">支持 JPG、PNG 格式，大小不超过 2MB</div>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 详细描述卡片 -->
        <el-card class="form-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-document"></i>
            <span>详细描述</span>
          </div>

          <el-form-item label="课程介绍" prop="introduce">
            <el-input type="textarea" v-model="form.introduce" placeholder="请输入课程介绍，详细描述课程内容、特色和适用人群等信息"
              :maxlength="200" :rows="6" show-word-limit resize="none">
            </el-input>
          </el-form-item>
        </el-card>

      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseEdit',
  data() {
    return {
      saving: false,
      loading: false,
      categories: [],
      videoFileName: '',
      // 上传状态管理
      imageUploading: false,
      imageUploadProgress: 0,
      videoUploading: false,
      videoUploadProgress: 0,
      coverUploading: false,
      coverUploadProgress: 0,
      form: {
        id: 0,
        name: '',
        typeId: '',
        courseType: '',
        calorie: '',
        exerciseDurationSec: 0,
        targetPeople: '',
        targetBodyParts: '',
        recommend: 0,
        status: 0,
        coverUrl: '',
        pictureUrl: '',
        videoUrl: '',
        introduce: ''
      },
      // 待上传的文件
      pendingImageFile: null,
      pendingVideoFile: null,
      pendingCoverFile: null,
      // 预览URL（用于显示选择的文件）
      previewImageUrl: '',
      previewVideoUrl: '',
      previewCoverUrl: '',
      rules: {
        name: [
          { required: true, message: '请输入课程名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        typeId: [
          { required: true, message: '请选择课程分类', trigger: 'change' }
        ],
        courseType: [
          { required: true, message: '请选择课程类型', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    isEdit() {
      return this.$route.params.id && this.$route.params.id !== 'add';
    },
    uploadUrl() {
      // 图片上传接口
      return this.$util.domain + '/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1'
    },
    videoUploadUrl() {
      // 视频上传接口
      return this.$util.domain + '/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=3'
    },
    uploadHeaders() {
      return {
        'Authorization': 'Bearer ' + (localStorage.getItem('token') || '')
      };
    }
  },
  created() {
    this.loadCategories();
    if (this.isEdit) {
      this.loadCourseDetail();
    }
  },
  methods: {
    async loadCategories() {
      try {
        const response = await this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/courseType/list',
          params: {
            status: 1, // 只获取启用的分类
            pageSize: 100, // 获取所有分类
            pageNumber: 1
          }
        });

        if (response.data.error === 10000) {
          const data = response.data.data;
          this.categories = data.resModels || [];
        } else {
          this.$message.error(response.data.message || '获取分类列表失败');
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
        this.$message.error('获取分类列表失败，请检查网络连接');
      }
    },

    async loadCourseDetail() {
      this.loading = true;
      try {
        const response = await this.$http({
          method: 'GET',
          url: this.$util.domain + '/adminapi/v1/course/detail',
          params: { id: this.$route.params.id }
        });

        if (response.data.error === 10000) {
          const data = response.data.data;
          this.form = {
            id: data.id,
            name: data.name,
            typeId: String(data.typeId || ''),
            courseType: String(data.courseType || ''),
            calorie: data.calorie || 0,
            exerciseDurationSec: data.exerciseDurationSec || 0,
            targetPeople: data.targetPeople ? String(data.targetPeople) : '',
            targetBodyParts: data.targetBodyParts || '',
            recommend: data.recommend == 1,
            status: data.status === 1,
            coverUrl: data.coverUrl || '',
            pictureUrl: data.pictureUrl || '',
            videoUrl: data.videoUrl || '',
            introduce: data.introduce || ''
          };

          // 如果有视频URL，提取文件名
          if (data.videoUrl) {
            this.videoFileName = this.extractFileName(data.videoUrl);
          }
        } else {
          this.$message.error(response.data.message || '获取课程详情失败');
          this.goBack();
        }
      } catch (error) {
        console.error('获取课程详情失败:', error);
        this.$message.error('获取课程详情失败，请检查网络连接');
        this.goBack();
      } finally {
        this.loading = false;
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    async save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }

        this.saving = true;

        try {
          // 先上传待上传的文件
          // 上传封面
          if (this.pendingCoverFile) {
            this.coverUploading = true;
            this.coverUploadProgress = 0;
            try {
              const coverUrl = await this.uploadFile(this.pendingCoverFile, true);
              this.form.coverUrl = coverUrl;
              this.pendingCoverFile = null;
              // 释放预览URL
              if (this.previewCoverUrl) {
                URL.revokeObjectURL(this.previewCoverUrl);
                this.previewCoverUrl = '';
              }
            } catch (error) {
              this.$message.error('封面上传失败: ' + error.message);
              return;
            } finally {
              this.coverUploading = false;
              this.coverUploadProgress = 0;
            }
          }

          if (this.pendingImageFile) {
            this.imageUploading = true;
            this.imageUploadProgress = 0;
            try {
              const imageUrl = await this.uploadFile(this.pendingImageFile, true);
              this.form.pictureUrl = imageUrl;
              this.pendingImageFile = null;
              // 释放预览URL
              if (this.previewImageUrl) {
                URL.revokeObjectURL(this.previewImageUrl);
                this.previewImageUrl = '';
              }
            } catch (error) {
              this.$message.error('图片上传失败: ' + error.message);
              return;
            } finally {
              this.imageUploading = false;
              this.imageUploadProgress = 0;
            }
          }

          if (this.pendingVideoFile) {
            this.videoUploading = true;
            this.videoUploadProgress = 0;
            try {
              const videoUrl = await this.uploadFile(this.pendingVideoFile, false);
              this.form.videoUrl = videoUrl;
              this.pendingVideoFile = null;
              // 释放预览URL
              if (this.previewVideoUrl) {
                URL.revokeObjectURL(this.previewVideoUrl);
                this.previewVideoUrl = '';
              }
            } catch (error) {
              this.$message.error('视频上传失败: ' + error.message);
              return;
            } finally {
              this.videoUploading = false;
              this.videoUploadProgress = 0;
            }
          }

          // 保存课程数据
          console.log('保存前的 form.status:', this.form.status, typeof this.form.status);
          const requestData = {
            id: this.isEdit ? this.form.id : 0,
            name: this.form.name,
            typeId: parseInt(this.form.typeId) || 0,
            courseType: parseInt(this.form.courseType) || 0,
            calorie: parseInt(this.form.calorie) || 0,
            exerciseDurationSec: parseInt(this.form.exerciseDurationSec) || 0,
            targetPeople: this.form.targetPeople ? parseInt(this.form.targetPeople) : 0,
            targetBodyParts: this.form.targetBodyParts || '',
            recommend: this.form.recommend ? 1 : 0,
            status: this.form.status ? 1 : 0,
            pictureUrl: this.form.pictureUrl,
            videoUrl: this.form.videoUrl,
            introduce: this.form.introduce,
            coverUrl: this.form.coverUrl
          };
          console.log('请求数据:', requestData);

          const response = await this.$http({
            method: 'POST',
            url: this.$util.domain + '/adminapi/v1/course/addOrEdit',
            body: JSON.stringify(requestData)
          });

          if (response.data.error === 10000) {
            this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
            this.goBack();
          } else {
            this.$message.error(response.data.message || '保存失败');
          }
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('保存失败，请检查网络连接');
        } finally {
          this.saving = false;
        }
      });
    },

    // 处理图片文件选择
    handleImageChange(file) {
      if (file.raw) {
        this.pendingImageFile = file.raw;
        // 创建预览URL
        this.previewImageUrl = URL.createObjectURL(file.raw);
        this.form.pictureUrl = ''; // 清空原有URL
      }
    },

    // 处理视频文件选择
    handleVideoChange(file) {
      if (file.raw) {
        this.pendingVideoFile = file.raw;
        // 创建预览URL
        this.previewVideoUrl = URL.createObjectURL(file.raw);
        this.videoFileName = file.name;
        this.form.videoUrl = ''; // 清空原有URL
      }
    },

    // 上传单个文件的方法
    async uploadFile(file, isImage = true) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('uploadFile', file);

        const uploadUrl = isImage ? this.uploadUrl : this.videoUploadUrl;

        this.$http({
          method: 'POST',
          url: uploadUrl,
          body: formData,
          headers: this.uploadHeaders
        }).then(response => {
          if (response.data.error === 10000) {
            resolve(response.data.data);
          } else {
            reject(new Error(response.data.message || '上传失败'));
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    beforeImageUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPGOrPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }

      return isJPGOrPNG && isLt2M;
    },

    beforeVideoUpload(file) {
      const isVideo = file.type.startsWith('video/');
      const isLt100M = file.size / 1024 / 1024 <100;

      if (!isVideo) {
        this.$message.error('只能上传视频文件!');
      }
      if (!isLt100M) {
        this.$message.error('上传视频大小不能超过 100MB!');
      }

      return isVideo && isLt100M;
    },

    handleImageProgress(event, file, fileList) {
      this.imageUploadProgress = Math.round(event.percent);
    },

    handleImageSuccess(response) {
      this.imageUploading = false;
      this.imageUploadProgress = 0;

      if (response.error === 10000) {
        // 修正：直接使用 response.data，而不是 response.data.url
        this.form.pictureUrl = response.data;
        this.$message.success('图片上传成功');
      } else {
        this.$message.error(response.message || '图片上传失败');
      }
    },

    handleImageError(error) {
      this.imageUploading = false;
      this.imageUploadProgress = 0;
      console.error('图片上传失败:', error);
      this.$message.error('图片上传失败，请重试');
    },

    previewImage() {
      if (this.form.pictureUrl) {
        window.open(this.form.pictureUrl, '_blank');
      }
    },

    removeImage() {
      this.$confirm('确定要删除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.pictureUrl = '';
        this.previewImageUrl = '';
        this.pendingImageFile = null;
        // 释放预览URL内存
        if (this.previewImageUrl) {
          URL.revokeObjectURL(this.previewImageUrl);
        }
        this.$message.success('图片已删除');
      }).catch(() => {
        // 用户取消删除
      });
    },

    beforeVideoUpload(file) {
      const isMP4 = file.type === 'video/mp4';
      const isLt100M = file.size / 1024 / 1024 < 100;

      if (!isMP4) {
        this.$message.error('上传视频只能是 MP4 格式!');
      }
      if (!isLt100M) {
        this.$message.error('上传视频大小不能超过 100MB!');
      }

      if (isMP4 && isLt100M) {
        this.videoUploading = true;
        this.videoUploadProgress = 0;
      }

      return isMP4 && isLt100M;
    },

    handleVideoProgress(event, file, fileList) {
      this.videoUploadProgress = Math.round(event.percent);
    },

    handleVideoSuccess(response) {
      this.videoUploading = false;
      this.videoUploadProgress = 0;

      if (response.error === 10000) {
        // 修正：直接使用 response.data 作为视频URL
        this.form.videoUrl = response.data;
        // 从URL中提取文件名
        this.videoFileName = this.extractFileName(response.data) || '视频文件';
        this.$message.success('视频上传成功');
      } else {
        this.$message.error(response.message || '视频上传失败');
      }
    },

    handleVideoError(error) {
      this.videoUploading = false;
      this.videoUploadProgress = 0;
      console.error('视频上传失败:', error);
      this.$message.error('视频上传失败，请重试');
    },

    previewVideo() {
      if (this.form.videoUrl) {
        window.open(this.form.videoUrl, '_blank');
      }
    },

    removeVideo() {
      this.$confirm('确定要删除这个视频吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.videoUrl = '';
        this.previewVideoUrl = '';
        this.pendingVideoFile = null;
        this.videoFileName = '';
        // 释放预览URL内存
        if (this.previewVideoUrl) {
          URL.revokeObjectURL(this.previewVideoUrl);
        }
        this.$message.success('视频已删除');
      }).catch(() => {
        // 用户取消删除
      });
    },

    extractFileName(url) {
      if (!url) return '';
      const parts = url.split('/');
      return parts[parts.length - 1] || '视频文件';
    },

    // 处理封面文件选择
    handleCoverChange(file) {
      if (file.raw) {
        this.pendingCoverFile = file.raw;
        // 创建预览URL
        this.previewCoverUrl = URL.createObjectURL(file.raw);
        this.form.coverUrl = ''; // 清空原有URL
      }
    },

    previewCover() {
      if (this.form.coverUrl || this.previewCoverUrl) {
        window.open(this.form.coverUrl || this.previewCoverUrl, '_blank');
      }
    },

    removeCover() {
      this.$confirm('确定要删除这个封面吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.coverUrl = '';
        this.previewCoverUrl = '';
        this.pendingCoverFile = null;
        // 释放预览URL内存
        if (this.previewCoverUrl) {
          URL.revokeObjectURL(this.previewCoverUrl);
        }
        this.$message.success('封面已删除');
      }).catch(() => {
        // 用户取消删除
      });
    }
  }
}
</script>

<style scoped>
.course-edit {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding: 0;
}

/* 页面头部样式 */
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px 0;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  flex: 1;
}

.page-title {
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title i {
  font-size: 32px;
  opacity: 0.9;
}

.page-subtitle {
  margin: 0;
  font-size: 16px;
  opacity: 0.8;
  font-weight: 400;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.header-actions .el-button {
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  color: white;
  backdrop-filter: blur(10px);
}

.header-actions .el-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

.header-actions .el-button--primary {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

.header-actions .el-button--primary:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* 表单容器样式 */
.form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px 40px;
}

.course-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* 卡片样式 */
.form-card {
  border-radius: 12px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  overflow: hidden;
}

.form-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  padding: 0;
}

.card-header i {
  font-size: 18px;
  color: #409eff;
}

/* 表单项样式优化 */
.form-card .el-form-item {
  margin-bottom: 32px;
  /* 增加底部间距，为验证提示留出空间 */
}

.form-card .el-form-item:last-child {
  margin-bottom: 0;
}

/* 验证错误提示样式 */
.el-form-item__error {
  position: static !important;
  /* 改为静态定位，避免重叠 */
  margin-top: 8px !important;
  padding: 6px 12px;
  font-size: 13px !important;
  color: #f56c6c !important;
  line-height: 1.5;
  background-color: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 4px;
  display: block !important;
  width: 100%;
  box-sizing: border-box;
}

.el-form-item__label {
  font-weight: 500;
  color: #606266;
  line-height: 1.6;
  /* 增加行高 */
}

.el-input__inner {
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
}

.el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.el-select .el-input__inner {
  cursor: pointer;
}

.el-textarea__inner {
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
  font-family: inherit;
}

.el-textarea__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 开关样式 */
.el-switch {
  display: flex;
  align-items: center;
}

/* 媒体上传样式 */
.media-upload-container {
  width: 100%;
}

.image-uploader,
.video-uploader {
  width: 100%;
}

.image-uploader .el-upload,
.video-uploader .el-upload {
  border: 2px dashed #d9d9d9;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-uploader .el-upload:hover,
.video-uploader .el-upload:hover {
  border-color: #409eff;
  background-color: rgba(64, 158, 255, 0.05);
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  height: 100%;
}

.upload-icon-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409eff, #67c23a);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.upload-icon {
  font-size: 24px;
  color: white;
  font-weight: bold;
}

.upload-text {
  color: #606266;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
}

.upload-tips {
  color: #909399;
  font-size: 14px;
  line-height: 1.4;
}

/* 上传成功后的内容样式 */
.uploaded-content {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.uploaded-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
}

.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.uploaded-content:hover .upload-overlay {
  opacity: 1;
}

.upload-actions {
  display: flex;
  gap: 12px;
}

.upload-actions .el-button {
  color: white;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.upload-actions .el-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.8);
}

/* 上传进度样式 */
.upload-progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 8px;
}

.progress-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 200px;
}

.upload-loading {
  font-size: 32px;
  color: #409eff;
  margin-bottom: 12px;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.progress-text {
  color: #606266;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.progress-percentage {
  color: #409eff;
  font-size: 14px;
  font-weight: 600;
  margin-top: 8px;
}

.el-progress {
  width: 100%;
}

.video-preview {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.preview-video {
  width: 100%;
  max-width: 280px;
  height: 160px;
  border-radius: 8px;
  object-fit: cover;
}

.video-name {
  margin-top: 8px;
  color: #606266;
  font-size: 14px;
  text-align: center;
  word-break: break-all;
  max-width: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .header-actions {
    justify-content: center;
  }

  .form-container {
    padding: 0 16px 40px;
  }

  .page-title {
    font-size: 24px;
    justify-content: center;
  }

  .el-col {
    margin-bottom: 16px;
  }
}

/* 加载状态优化 */
.el-button.is-loading {
  position: relative;
}

.el-button.is-loading::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border-radius: inherit;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: loading-shine 1.5s infinite;
}

@keyframes loading-shine {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

/* 表单验证样式优化 */
.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-textarea__inner {
  border-color: #f56c6c;
  box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.1);
}

.el-form-item__error {
  font-size: 12px;
  color: #f56c6c;
  padding-top: 4px;
}

/* 选择器选项样式 */
.el-select-dropdown__item {
  padding: 12px 20px;
  transition: all 0.3s ease;
}

.el-select-dropdown__item:hover {
  background-color: #f5f7fa;
}

.el-select-dropdown__item.selected {
  background-color: #409eff;
  color: white;
}
</style>


// WEBPACK FOOTER //
// courseEdit.vue?4c9274da